import bindAllOfThis from 'src/utils/BindThisHelper';
import { PhaserGeneralGameObjectType, TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import TranslateApi from 'src/utils/TranslateHelper';
import { PhaserButtonConfig } from 'src/games/shared/Button';
import { PhaserModalConfig, PhaserModal } from 'src/games/shared/Modal';
import { Color } from 'src/games/shared/ColorValue';
import { EndGameScene } from './EndGameScene';
import { Book, BookSlot } from '../objects/Books';

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;
    shelves: Phaser.GameObjects.Image;

    books: Book[];
    slots: BookSlot[];

    constructor() {
        super({
            key: "MainScene"
        });
        bindAllOfThis(this, MainScene.prototype);
    }

    preload(): void {
        this.load.tilemapTiledJSON('map', require("/src/assets/qci/maps/librarian.json"));
        this.load.image('background', require('/src/assets/qci/backgrounds/kc_background.png'));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameLibrarian.png"), require("src/assets/qci/atlas/gameLibrarian.json"));
    }

    initialize(): void {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
        this.books = [];
        this.slots = [];

    }

    create(): void {
        this.initialize();
        var white = this.add.image(0, 0, "pixel").setOrigin(0).setDisplaySize(this.gameWidth, this.gameHeight);
        this.shelves = this.add.image(0, 0, "background").setOrigin(0).setDepth(0.5);

        var table = this.add.image(60, 0, "assets", "table");
        table.setOrigin(0);
        table.setY(this.gameHeight - table.height);
        table.setDepth(1);

        this.createShelves();
        this.createBooks();
        this.registerEvents();
    }

    createBooks() {
        this.map.getObjectLayer('Books').objects.forEach((ob: TiledGameObject) => {
            var book = new Book(this, ob);
            book.setDepth(1);
            this.books.push(book);
        });
    }

    createShelves() {
        this.map.getObjectLayer('Shelves').objects.forEach((ob: TiledGameObject) => {
            if (ob.type === "Book") {
                var spot = new BookSlot(this, ob);
                this.slots.push(spot);
            }
        });
    }

    registerEvents(): void {
        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, book: Book) => {
            this.children.bringToTop(book);
            book.setScale(0.75);
            pointer.x = book.x;
            pointer.y = book.y;
        });

        this.input.on('drag', (pointer: Phaser.Input.Pointer, book: Book, dragX: number, dragY: number) => {
            book.x = pointer.x;
            book.y = pointer.y;
        });

        this.input.on('dragend', (pointer: Phaser.Input.Pointer, book: Book, dropped: boolean) => {
            if (!dropped) {
                this.putBack(book);
            }
        });

        this.input.on('drop', (pointer: Phaser.Input.Pointer, book: Book, slot: BookSlot) => {
            this.drop(book, slot);
        });
    }

    drop(book: Book, slot: BookSlot) {
        // Lock book in place
        if (book.id === slot.id) {
            book.onShelf = true;
            book.input.enabled = false;
            slot.input.enabled = false;
            book.x = slot.shelfX;
            book.y = slot.y + 10;
            book.setScale(0.75);
        }
        else {
           this.putBack(book);
        }

        this.isGameOver();
    }

    putBack(book: Book) {
        book.x = book.input.dragStartX;
        book.y = book.input.dragStartY;
        book.setScale(1);
    }

    isGameOver(): boolean {
        for (var b of this.books) {
            if (!b.onShelf) {
                return;
            }
        }

        this.input.enabled = false;

        // Wait a second and then end the game
        setTimeout(() => {
            this.scene.add("EndGameScene", EndGameScene, true);
            this.scene.remove(this);
        }, 1000);

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/games/LibrarianGame/scenes/MainScene.ts